import React, { useCallback, useRef } from 'react';

import { rootUiActions } from 'app-components/flux/root-ui';
import type { TransactionRuleType } from 'app-components/flux/transaction-rules/transactionRulesTypes';
import type { TransactionProps } from 'app-components/flux/transactions/transactionsTypes';
import { useAppDispatch } from 'hooks/redux';

import LlmRuleStdDialog from './StdDialog';

export const DIALOG_TYPE_LLM_RULE = 'LLM_RULE';

type LlmRuleDialogProps = {
  dialogId: string;
  rule?: TransactionRuleType;
  transaction?: Partial<TransactionProps>;
  hasAIEdits?: boolean;
  callback?: (rule?: TransactionRuleType) => void;
};

const LlmRuleDialog = ({ dialogId, rule, transaction, hasAIEdits, callback }: LlmRuleDialogProps) => {
  const dispatch = useAppDispatch();
  const callbackFiredRef = useRef(false);

  const handleClose = useCallback(
    (newRule?: TransactionRuleType) => {
      if (callbackFiredRef.current) return;
      callbackFiredRef.current = true;
      callback?.(newRule);
      dispatch(rootUiActions.removeDialog(dialogId));
    },
    [callback, dialogId, dispatch],
  );

  return (
    <LlmRuleStdDialog
      dialogId={dialogId}
      rule={rule}
      transaction={transaction as TransactionProps | undefined}
      hasAIEdits={hasAIEdits}
      handleClose={handleClose}
    />
  );
};

export default LlmRuleDialog;
